import { render, staticRenderFns } from "./AddMarket.vue?vue&type=template&id=f8eb26e4"
import script from "./AddMarket.vue?vue&type=script&lang=js"
export * from "./AddMarket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports